import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';

export const EntranceDateSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formDateOfBirth">
                <Form.Label>Frühestmöglicher Eintritt</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Frühestmöglichen Eintrittstermin eingeben"
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};